import { render, staticRenderFns } from "./ReturnInfo.vue?vue&type=template&id=7c15da26&scoped=true"
import script from "./ReturnInfo.vue?vue&type=script&lang=js"
export * from "./ReturnInfo.vue?vue&type=script&lang=js"
import style0 from "./ReturnInfo.vue?vue&type=style&index=0&id=7c15da26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c15da26",
  null
  
)

export default component.exports